module.exports = __webpack_public_path__ + "media/images/guide-5t-651334a74bf2eb965e3c71ecbb057752.png";